import React, { useRef } from 'react';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import Navbar from './navbar';
import Login from "./login";
import {
    Accordion, Alert,
    Card,
    Col,
    Container,
    ListGroup,
    Nav,
    Row,

} from "react-bootstrap";
import { getAuthHeader } from "./Util";
import { useState } from "react";
import { Prev } from 'react-bootstrap/esm/PageItem';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import loader from '../page_preload.gif'
import { set } from 'lodash';
import { Modal } from "react-bootstrap";
import { GolfCourseRounded } from '@material-ui/icons';
import NotificationSystem from 'react-notification-system';


function DiagramUpload() {
    const [Msg, setMsg] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState(0);
    const directoryRef = useRef();
    const inputFileRef = useRef();
    const [validProdNum, setvalidProdNum] = useState(false);
    const [data, setData] = useState([]);
    const [Loading, setLoading] = useState(false);
    const [showHide, setShowHide] = useState(false);
    const [imagePath, setImagePath] = useState('');
    // Copy All Diagram modal state
    const [showCopyAllModal, setShowCopyAllModal] = useState(false);
    const [copyToProductNumbers, setCopyToProductNumbers] = useState('');
    // Individual Copy modal state
    const [showCopyModal, setShowCopyModal] = useState(false);
    const [copyDiagramDetails, setCopyDiagramDetails] = useState(null);
    const [copyRowToProductNumbers, setCopyRowToProductNumbers] = useState('');
    // Rename modal state
    const [showRenameModal, setShowRenameModal] = useState(false);
    const [renameNewName, setRenameNewName] = useState('');
    const [renameDetails, setRenameDetails] = useState(null);
    const [renameError, setRenameError] = useState('');
    // Error message state for copy modals
    const [copyErrorMsg, setCopyErrorMsg] = useState("");
    // Handlers to stop loading after modal closes
    const handleCopyAllModalExited = () => setLoading(false);
    const handleCopyModalExited = () => setLoading(false);
    const [validatingCopy, setValidatingCopy] = useState(true);
    // Store valid filtered numbers for copy modals
    const [validCopyAllNumbers, setValidCopyAllNumbers] = useState([]);
    const [validCopyRowNumbers, setValidCopyRowNumbers] = useState([]);

    const handleFileChange = (event) => {
        const fileNamePattern = /^[a-zA-Z0-9._-]+$/;
        //Perform Validation on Files for filename length and file type
        const file = event.target.files[0];
        setMsg([]);
        setSelectedFiles(file);

        const fileName = file.name;
        const fileType = file.type;

        // Perform validation for file type
        if (!fileType.includes("image/jpeg")) {
            setMsg(prevItems => [...prevItems, fileName + " :Only jpg file type is allowed."]);
            inputFileRef.current.value = ''
            event.preventDefault();
        }

        // Perform validation for filename length
        if (fileName.length > 255) {
            setMsg(prevItems => [...prevItems, fileName + " :Filename length should not exceed 255 characters."]);
            inputFileRef.current.value = ''
            event.preventDefault();
        }
        // Perform validation for file type
        if (!fileType.includes("image/jpeg") && !fileType.includes("image/gif")) {
            setMsg(prevItems => [...prevItems, "Only jpeg and gif file types are allowed."]);
            inputFileRef.current.value = ''
            event.preventDefault();
        }
        if (file.size > 10000000) {
            setMsg(prevItems => [...prevItems, fileName + " :File size should not exceed 10MB."]);
            inputFileRef.current.value = ''
            event.preventDefault();
        }
        if (!fileNamePattern.test(fileName)) {
            setMsg(prevItems => [...prevItems, fileName + " :File name contains invalid characters or Spaces."]);
            inputFileRef.current.value = ''
            event.preventDefault();
        }
    }

    const HandleSubmit = (event) => {
        setMsg([]);
        if (inputFileRef.current.value == '') {
            setMsg(prevItems => [...prevItems, "Please select file to Upload!!"]);
            event.preventDefault();
        }
        if (document.getElementById('name').value == '') {
            setMsg(prevItems => [...prevItems, "Please Enter Name!!"]);
            event.preventDefault();
        }


        if (inputFileRef.current.value != '' && document.getElementById('name').value != '') {
            const url = `${process.env.REACT_APP_API}/Proxy/DiagramUpload?input=/Files/files/UploadDiagram`
            const formData = new FormData();
            formData.append('file', selectedFiles);
            formData.append('directory', directoryRef.current.value);
            formData.append('name', document.getElementById('name').value);
            formData.append('product', document.getElementById('prodNum').value);
            setLoading(true);
            axios.post(url, formData, {
                headers: {
                    ...getAuthHeader(),
                    'Content-Type': 'multipart/form-data'
                },
            })
                .then((res) => {
                    setMsg(prevItems => [...prevItems, <span style={{ color: 'green' }}> New Diagram Added Successfully.</span>]);
                    inputFileRef.current.value = '';
                    document.getElementById('name').value = '';
                    getData(document.getElementById('prodNum').value);
                    setLoading(false);
                })
                .catch((error) => {
                    setMsg(prevItems => [...prevItems, "Error Occurred while uploading diagram, Please try again"]);
                    setLoading(false);
                });
        }
    }

    function getData(product) {
        let urlprod;
        urlprod = `${process.env.REACT_APP_API}/proxy/get?input=/Files/files/GetDiagramDetail/` + product;
        setLoading(true);
        axios.get(urlprod, {
            headers: {
                ...getAuthHeader()
            }
        })
            .then((res) => {
                if (res.data.length > 0) {
                    setvalidProdNum(true);
                    setLoading(false);
                    setData(res.data);
                    directoryRef.current.value = res.data[0].Directory;
                    directoryRef.current.disabled = true;
                }
                else {
                    setvalidProdNum(true);
                    setData(res.data);
                    directoryRef.current.value = product;
                    directoryRef.current.disabled = false;
                    setLoading(false);
                }
                document.getElementById('name').value = '';
                inputFileRef.current.value = '';
            }, (error) => {
                setMsg(prevItems => [...prevItems, "Error Occurred while fetching diagram details, Please try again"]);
            })
    }


    const handleBlur = (event) => {
        setMsg([]);
        if (event.target.value == "") {
            setvalidProdNum(false);
        }
        else {
            let urlprod;
            var product = event.target.value;
            setLoading(true);
            urlprod = `${process.env.REACT_APP_API}/proxy/get?input=/Files/files/Checkproductnumberexist/` + event.target.value;
            axios.get(urlprod, {
                headers: {
                    ...getAuthHeader()
                }
            })
                .then((res) => {
                    if (res.data == 'Product exists') {
                        getData(product);
                    }
                    else {
                        setMsg(prevItems => [...prevItems, "Product does not exists"]);
                        setvalidProdNum(false);
                        setLoading(false);
                    }

                }, (error) => {
                    setLoading(false);
                    setvalidProdNum(false);
                    setMsg(prevItems => [...prevItems, "Error Occurred while checking product number"]);
                })
        }
    };
    const handleDelete = (directory, file) => {
        setMsg([]);
        const confirmed = window.confirm("Are you sure you want to delete this item?");
        if (confirmed) {
            let urlprod;
            setLoading(true);
            urlprod = `${process.env.REACT_APP_API}/proxy/get?input=/Files/files/DeleteDiagram/` + directory + '/' + file;
            axios.get(urlprod, {
                headers: {
                    ...getAuthHeader()
                }
            })
                .then((res) => {

                    setMsg(prevItems => [...prevItems, "Diagram deleted successfully"]);
                    getData(document.getElementById('prodNum').value);
                    setLoading(false);

                }, (error) => {
                    setLoading(false);
                    setMsg(prevItems => [...prevItems, "Error Occurred while Deleting Diagram"]);
                })
        }
    }

    const showDaigram = (file) => {
        setImagePath(`${process.env.REACT_APP_DIAGRAM_PATH}` + directoryRef.current.value + '/' + file);
        setShowHide(true);
    }

    const closeModal = () => {
        setShowHide(false);
    };

    const makeUpperCase = (event) => {
        event.target.value = event.target.value.toUpperCase();
    }

    // Validate product numbers (comma separated) using API, batching to avoid overload
    // Auto-filters invalid ones and removes duplicates, returns valid numbers
    const validateProductNumbers = async (input, setError, setValidNumbers) => {
        const nums = input.split(',').map(n => n.trim().toUpperCase()).filter(Boolean);
        
        // Remove duplicates using Set
        const uniqueNums = [...new Set(nums)];
        const duplicatesRemoved = nums.length - uniqueNums.length;
        
        if (uniqueNums.length === 0) {
            setError('Copy To Product Numbers is required.');
            setValidNumbers([]);
            return false;
        }
        setLoading(true);
        const batchSize = 10;
        let validNums = [];
        let invalids = [];
        try {
            for (let i = 0; i < uniqueNums.length; i += batchSize) {
                const batch = uniqueNums.slice(i, i + batchSize);
                const results = await Promise.all(batch.map(num =>
                    axios.get(`${process.env.REACT_APP_API}/proxy/get?input=/Files/files/Checkproductnumberexist/${num}`, {
                        headers: { ...getAuthHeader() }
                    }).then(res => ({ num, valid: !!res.data && res.data == 'Product exists'}))
                    .catch(() => ({ num, valid: false }))
                ));
                validNums = validNums.concat(results.filter(r => r.valid).map(r => r.num));
                invalids = invalids.concat(results.filter(r => !r.valid).map(r => r.num));
            }
            
            setValidNumbers(validNums);
            
            if (invalids.length > 0 && validNums.length > 0) {
                // Some invalid, some valid - inform user and auto-filter
                let errorMsg = '';
                if (duplicatesRemoved > 0) {
                    errorMsg += `${duplicatesRemoved} duplicate number(s) removed. `;
                }
                errorMsg += `Invalid numbers removed: ${invalids.join(', ')}. You can add more valid numbers or click OK to proceed with ${validNums.length} valid number(s).`;
                setError(errorMsg);
                setLoading(false);
                return true; // Return true to allow proceeding with valid numbers
            } else if (invalids.length > 0 && validNums.length === 0) {
                // All invalid
                let errorMsg = '';
                if (duplicatesRemoved > 0) {
                    errorMsg += `${duplicatesRemoved} duplicate number(s) removed. `;
                }
                errorMsg += 'All product numbers are invalid: ' + invalids.join(', ');
                setError(errorMsg);
                setLoading(false);
                return false;
            } else {
                // All valid
                let errorMsg = '';
                if (duplicatesRemoved > 0) {
                    errorMsg = `${duplicatesRemoved} duplicate number(s) removed.`;
                }
                setError(errorMsg);
                setLoading(false);
                return true;
            }
        } catch (e) {
            setError('Validation error.');
            setLoading(false);
            return false;
        }
    };
    // Combined handler for both Copy All and Individual Copy
    const handleCopyDiagram = async ({
        toProductNumbers,
        diagramDetails = null,
        validNumbers = [],
        closeModal
    }) => {
        setCopyErrorMsg("");
        setMsg([]);
        const fromProduct = document.getElementById('prodNum')?.value || '';
        // Use pre-validated numbers if available, otherwise parse and filter
        const toProducts = validNumbers.length > 0 
            ? validNumbers.join(',') 
            : toProductNumbers.split(',').map(num => num.trim()).filter(Boolean).join(',');
        // For individual copy, use diagramDetails; for copy all, leave blank
        const directory = diagramDetails?.Directory || '';
        const filename = diagramDetails?.Diagrame || '';
        const description = diagramDetails?.Description || '';

        if (!fromProduct) {
            setCopyErrorMsg("Copy from product number is required.");
            return;
        }
        if (diagramDetails && (!directory || !filename)) {
            setCopyErrorMsg("Directory and filename are required.");
            return;
        }
        if (!toProducts) {
            setCopyErrorMsg("Copy To Product Numbers is required.");
            return;
        }

        setLoading(true);
        const formData = new FormData();
        formData.append('fromProduct', fromProduct);
        formData.append('directory', directory);
        formData.append('filename', filename);
        formData.append('description', description);
        formData.append('toProducts', toProducts);

        axios.post(`${process.env.REACT_APP_API}/Proxy/DiagramUpload?input=/Files/files/CopyDiagram`, formData, { headers: { ...getAuthHeader() } })
            .then(() => {
                setMsg(prev => [...prev, <span style={{ color: 'green' }}>Copied successfully</span>]);
                closeModal();
            })
            .catch((error) => {
                setCopyErrorMsg("Error occurred while copying the diagram. Please try again.");
                 setLoading(false) 
            });
    };
    // Helper to open Copy All modal and clear fields
    const openCopyAllModal = () => {
        setMsg([]);
        setCopyErrorMsg("");
        setCopyToProductNumbers("");
        setShowCopyAllModal(true);
    };
    // Helper to open row Copy modal and clear fields
    const openCopyModal = (item) => {
        setMsg([]);
        setCopyDiagramDetails(item);
        setCopyRowToProductNumbers("");
        setCopyErrorMsg("");
        setShowCopyModal(true);
    };

    // Open rename modal pre-filled with current diagram name
    const openRenameModal = (item) => {
        setMsg([]);
        setRenameDetails(item);
        setRenameNewName(item?.Description || '');
        setRenameError('');
        setShowRenameModal(true);
    };

    const closeRenameModal = () => {
        setShowRenameModal(false);
        setRenameDetails(null);
        setRenameNewName('');
        setRenameError('');
    };

    // Called when user confirms rename. Closes modal on success.
    const handleRename = async (newName) => {
        if (!newName || newName.trim() === '') {
            setRenameError('Please enter a new name.');
            return;
        }
        const product = document.getElementById('prodNum')?.value || '';
        if (!product) {
            setRenameError('Product number missing.');
            return;
        }
        setLoading(true);

         await axios.post(`${process.env.REACT_APP_API}/proxy/post?input=/Files/files/RenameDiagram/${renameDetails?.picture_Id}`,
            JSON.stringify(newName.trim()), {
            headers: {
                'content-type': 'application/json',
                ...getAuthHeader()
            }
        }).then((res) => {
            setMsg(prevItems => [...prevItems, <span style={{ color: 'green' }}> Diagram renamed successfully.</span>]);
            setLoading(false);
            closeRenameModal();
            getData(product);
        }).catch((error) => {
            setLoading(false);
            setRenameError('Error occurred while renaming. Please try again.');
        });
    };

    return (
        <div>
            <React.Fragment>
                <div style={{ position: 'relative', boxSizing: 'border-box' }}>
                    {Loading && <div>
                        <div style={{
                            position: 'fixed',
                            height: '100%',

                            zIndex: 2000,
                            display: 'block', width: '100%', textAlign: 'center'
                            , top: '40%'
                        }}>
                            <img src={loader} alt="loading..." />
                            <br />
                            Please wait for the moment....
                        </div>
                    </div>}
                    {Loading ? <div style={{ opacity: '0.5' }}>

                    </div> : null}
                </div>

                <form>
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label> <b>Enter Product Number to Begin: </b></label>
                            <input type="text" class="form-control" id="prodNum" onBlur={handleBlur} onKeyUp={makeUpperCase} placeholder="Enter Product Number" />
                        </div>
                        {validProdNum && (
                            <><div class="form-group col-md-4">
                                <label><b>Directory:</b></label>
                                <input type="text" class="form-control" id="dir" ref={directoryRef} onKeyUp={makeUpperCase} />
                            </div><div /></>
                        )}
                    </div>
                    {validProdNum && (
                        <>
                            <div class="form-row">
                                <div class="form-group col-md-4">
                                    <label > <b>Enter Name: </b></label>
                                    <input type="text" class="form-control" id="name" placeholder="Enter Name" onKeyUp={makeUpperCase} />
                                </div>
                                <div class="form-group col-md-4">
                                    <label > <b>Select File: </b></label>
                                    <input type="file" class="form-control" accept="image/jpeg" id="file" placeholder="Select File to Upload" onChange={handleFileChange} ref={inputFileRef} />
                                </div>
                            </div>
                        </>
                    )}
                    {validProdNum && (
                        <>
                            <button type="button" className="btn btn-primary" onClick={HandleSubmit}>Add New Diagram</button>
                            <button type="button" className="btn btn-secondary ml-2" style={{ marginLeft: '10px' }} onClick={openCopyAllModal}>Copy All Diagram</button>
                        </>
                    )}
                </form>
                <br />
                < Row >
                    <Col xs={"12"} sm={"12"} md={"12"} lg={"7"} xl={"8"} >

                        <ul>
                            {
                                Msg.map(item => (
                                    <li style={{ color: 'red' }} > {item} </li>
                                ))}
                        </ul>

                    </Col></Row >
                {validProdNum && (
                    <div>
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th>Directory</th>
                                    <th>Name</th>
                                    <th>File</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!data.length > 0 && (
                                    <tr>
                                        <td colSpan={4}><center>No Data Found</center></td>
                                    </tr>
                                )}
                                {data.map(item => (
                                    <tr>
                                        <td>{item.Directory}</td>
                                        <td>{item.Description}</td>
                                        <td style={{ cursor: "pointer" }} title="Click to view Diagram" onClick={() => showDaigram(item.Diagrame)}><u>{item.Diagrame}</u></td>
                                        <td>
                                            <button className="btn btn-secondary btn-info btn-sm mr-2" style={{ marginRight: '5px' }} onClick={() => openCopyModal(item)}>Copy</button>
                                            <button className="btn btn-secondary btn-info btn-sm mr-2" style={{ marginRight: '5px' }} onClick={() => openRenameModal(item)}>Rename</button>
                                            <button onClick={() => handleDelete(item.Directory, item.Diagrame)}>Delete</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>)}

            </React.Fragment >

            <React.Fragment>
                <Modal size="lg" scrollable show={showHide} onHide={closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>View Diagram</Modal.Title>
                    </Modal.Header>
                    <Modal.Body id="PopupId">
                        <img id="diaImg" className="responsive" src={imagePath} alt="Image Cannot Be Displayed" ></img>
                    </Modal.Body>
                    <Modal.Footer>
                    </Modal.Footer>
                </Modal>

                {/* Copy All Diagram Modal */}
                <Modal show={showCopyAllModal}  onExited={handleCopyAllModalExited}
onHide={() => setShowCopyAllModal(false)} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Copy All Diagrams</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            <label>Copy From Product Number</label>
                            <input type="text" className="form-control" value={document.getElementById('prodNum')?.value || ''} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Copy To Product Numbers (comma separated)</label>
                            <input
                                type="text"
                                className="form-control"
                                value={copyToProductNumbers}
                                onChange={e => {
                                    setCopyToProductNumbers((e.target.value).toUpperCase());
                                }}
                                onBlur={async e => {
                                    setValidatingCopy(true);
                                    await validateProductNumbers(e.target.value, setCopyErrorMsg, (validNums) => {
                                        setValidCopyAllNumbers(validNums);
                                        // Update input to show only unique valid numbers
                                        setCopyToProductNumbers(validNums.join(', '));
                                    });
                                    setValidatingCopy(false);
                                }}
                                onPaste={e => {
                                    e.preventDefault();
                                    const pasted = e.clipboardData.getData('Text').trim();
                                    const input = e.target;
                                    // If all text is selected, replace; else append
                                    if (input.selectionStart === 0 && input.selectionEnd === input.value.length) {
                                        setCopyToProductNumbers(pasted);
                                    } else {
                                        // Only add comma if both prev and pasted don't already have it
                                        const needsComma = copyToProductNumbers.trim() && !copyToProductNumbers.trim().endsWith(',') && !pasted.startsWith(',');
                                        setCopyToProductNumbers(prev => (prev ? prev + (needsComma ? ', ' : '') : '') + pasted);
                                    }
                                }}
                                placeholder="Enter product numbers"
                            />
                            {copyErrorMsg && showCopyAllModal && (
                                <div style={{ color: 'red', marginTop: 4 }}>{copyErrorMsg}</div>
                            )}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-primary"
                        disabled={validatingCopy || copyToProductNumbers.trim() === ''}
                        onClick={() => handleCopyDiagram({
                            toProductNumbers: copyToProductNumbers,
                            diagramDetails: null,
                            validNumbers: validCopyAllNumbers,
                            closeModal: () => setShowCopyAllModal(false)
                        })}
                        >OK</button>
                        <button className="btn btn-secondary" onClick={() => setShowCopyAllModal(false)}>Cancel</button>
                    </Modal.Footer>
                </Modal>
            </React.Fragment>

            {/* Individual Copy Modal */}
            <Modal show={showCopyModal} onExited={handleCopyModalExited}
            onHide={() => setShowCopyModal(false)} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Copy Diagram</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {copyDiagramDetails && (
                        <>
                            <div className="form-group">
                                <label>Copy From Product Number</label>
                                <input type="text" className="form-control" value={document.getElementById('prodNum')?.value || ''} readOnly />
                            </div>
                            <div className="form-group">
                                <label>Diagram Name</label>
                                <input type="text" className="form-control" value={copyDiagramDetails.Description} readOnly />
                            </div>
                            <div className="form-group">
                                <label>Diagram File</label>
                                <input type="text" className="form-control" value={copyDiagramDetails.Diagrame} readOnly />
                            </div>
                            <div className="form-group">
                                <label>Copy To Product Numbers (comma separated)</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={copyRowToProductNumbers}
                                    onChange={e => {
                                        setCopyRowToProductNumbers((e.target.value).toUpperCase());
                                    }}
                                    onBlur={async e => {
                                        setValidatingCopy(true);
                                        await validateProductNumbers(e.target.value, setCopyErrorMsg, (validNums) => {
                                            setValidCopyRowNumbers(validNums);
                                            // Update input to show only unique valid numbers
                                            setCopyRowToProductNumbers(validNums.join(', '));
                                        });
                                        setValidatingCopy(false);
                                    }}
                                    onPaste={e => {
                                        e.preventDefault();
                                        const pasted = e.clipboardData.getData('Text').trim();
                                        const input = e.target;
                                        // If all text is selected, replace; else append
                                        if (input.selectionStart === 0 && input.selectionEnd === input.value.length) {
                                            setCopyRowToProductNumbers(pasted);
                                        } else {
                                            // Only add comma if both prev and pasted don't already have it
                                            const needsComma = copyRowToProductNumbers.trim() && !copyRowToProductNumbers.trim().endsWith(',') && !pasted.startsWith(',');
                                            setCopyRowToProductNumbers(prev => (prev ? prev + (needsComma ? ', ' : '') : '') + pasted);
                                        }
                                    }}
                                    placeholder="Enter product numbers"
                                />
                                {/* Show error message under the field if present */}
                                {copyErrorMsg && showCopyModal && (
                                    <div style={{ color: 'red', marginTop: 4 }}>{copyErrorMsg}</div>
                                )}
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" disabled={validatingCopy || copyRowToProductNumbers.trim() === ''} onClick={() => handleCopyDiagram({
                        toProductNumbers: copyRowToProductNumbers,
                        diagramDetails: copyDiagramDetails,
                        validNumbers: validCopyRowNumbers,
                        closeModal: () => setShowCopyModal(false)
                    })}>OK</button>
                    <button className="btn btn-secondary" onClick={() => setShowCopyModal(false)}>Cancel</button>
                </Modal.Footer>
            </Modal>

                {/* Rename Diagram Modal */}
                <Modal show={showRenameModal} onHide={closeRenameModal} backdrop="static" onExited={() => setLoading(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Rename Diagram</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            <label>File Name</label>
                            <input type="text" className="form-control" value={renameDetails?.Diagrame || ''} readOnly />
                        </div>
                        <div className="form-group">
                            <label>Current Name</label>
                            <input type="text" className="form-control" value={renameDetails?.Description || ''} readOnly />
                        </div>
                        <div className="form-group">
                            <label>New Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={renameNewName}
                                onChange={e => setRenameNewName(e.target.value.toUpperCase())}
                                placeholder="Enter new diagram name"
                            />
                            {renameError && <div style={{ color: 'red', marginTop: 4 }}>{renameError}</div>}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-primary" onClick={() => handleRename(renameNewName)}>Rename</button>
                        <button className="btn btn-secondary" onClick={closeRenameModal}>Cancel</button>
                    </Modal.Footer>
                </Modal>
            </div>
    )
}
export default DiagramUpload;
